import { createSettingsStore } from './settings';
import { createUserStore } from '../modules/user/user.store';
import { createProjectConfigStore } from '../modules/projects/project-config.store';
import { createReportStore } from '../modules/report/report.store';
import { createAlertStore } from './alert';
import { createProgressStore } from './progress';
import { totalCount } from './widget';
import { createSelectedDayOptionStore } from './days';
import { createSelectedSortingStore } from './sorting';
import { UiError } from '../lib/errors';
import { ItemService } from '../modules';
import { ItemStatus } from '../modules/item/item.constants';
export const settings = createSettingsStore();
export const user = createUserStore();
export const projectConfigs = createProjectConfigStore();
export const report = createReportStore();
export const alert = createAlertStore();
export const progress = createProgressStore();
export const day = createSelectedDayOptionStore();
export const sorting = createSelectedSortingStore();
export const total = totalCount;
function getItemIdByMessage(message) {
    const itemId = message.split('_#$%_').reverse()[1];
    return Number(itemId);
}
async function changeItemStatus(message) {
    const itemId = getItemIdByMessage(message);
    await ItemService.updateStatus(itemId, ItemStatus.DISMISSED);
}
export const wrapProgress = (cb, throwUiError) => {
    return async function _wrapProgress(...args) {
        progress.start();
        try {
            await cb.call(null, ...args);
        }
        catch (error) {
            if (error instanceof UiError) {
                if (error.code === 503) {
                    alert.show(error.message, 'Remove From Report', () => changeItemStatus(error.message));
                }
                else {
                    alert.show(error.message);
                }
                if (throwUiError) {
                    throw error;
                }
            }
            else {
                throw error;
            }
        }
        finally {
            progress.finish();
        }
    };
};
